firebird.factory('contentService', [
    '$rootScope',
    'logService',
    '$window',
    '$timeout',
    'socketService',
    'attendeeService',
    'notificationService',
    'helperService',
    'configService',
    'analyticsWrapperService',
    'vertoService',
    'meetingService',
    'brandingService',
    'localizationService',
    'contentStateService',
    'contentUpgradedService',
    'subscriptionService',
    function (
        $rootScope,
        logService,
        $window,
        $timeout,
        socketService,
        attendeeService,
        notificationService,
        helperService,
        configService,
        analyticsWrapperService,
        vertoService,
        meetingService,
        brandingService,
        localizationService,
        contentStateService,
        contentUpgradedService,
        subscriptionService
    ) {
        //Serves as a 'funnel' for all content (slides, videos, screenshare)
        //Keeps track of who initiates/starts/stops content
        var self = this;

        var contentOverride = false;
        var contentOverrideObj = { type: '', path: '', ref: null };
        var _isContentMaximized = false;
        var unrequestedStopType = '';

        var contentInitiationTimeout;
        var screenShareInitiationTimeout;

        var isHostingSFUScreenShare = false;
        var screenShareType = 'monitor';
        var hostType = 'browser';

        let rootSubscription;
        // these parameters are being handled by angular subscriptions
        let currentContentOwner;
        let currentContentType;
        let currentContentPath;
        let isLocalContentShared;

        /* for slides currentContentObj object is:
            type: 'slides',
            path: self.loadedContentURL,
            requesterName: self.requesterName,
            playStatus: playStatus,
            currentPage: self.currentSlide,
            pageCount: self.contentPageCount

            for sceenshare:
            type: 'screenshare',
            requesterName: self.requesterName

            for video:
            type: 'video',
            path: self.loadedContentURL,
            requesterName: self.requesterName,
            playStatus: playStatus
        */
        let currentContentObj = null;

        let isVideoShareActive = false;
        let isScreenShareActive = false;

        var service = {
            isContentPlaying: isContentPlaying,
            getContentOwner: getContentOwner,
            setContentOwner: setContentOwner,
            playContent: playContent,
            cancelContentInitiation: cancelContentInitiation,
            stopCurrentContent: stopCurrentContent,
            promptUserOverride: promptUserOverride,
            startNewContent: startNewContent,
            overrideCurrentContent: overrideCurrentContent,
            isContentMaximized: isContentMaximized,
            toggleMaximizeContent: toggleMaximizeContent,
            onContentMaximizeStatus: onContentMaximizeStatus,
            isContentInitiating: isContentInitiating,
            getContentType: getContentType,
            setContentType: setContentType,
            getCurrentContentObject: getCurrentContentObject,
            setCurrentContentObject: setCurrentContentObject,
            getContentPath: getContentPath,
            setContentPath: setContentPath,
            getIsFilePlay: getIsFilePlay,
            init: init,
            hasUnrequestedStop: hasUnrequestedStop,
            setUnrequestedStopType: setUnrequestedStopType,
            getUnrequestedStopType: getUnrequestedStopType,
            startContentInitTimeout: startContentInitTimeout,
            cancelContentInitTimeout: cancelContentInitTimeout,
            resetContentProperties: resetContentProperties,

            //SFU-Related
            setIsHostingSFUScreenShare: setIsHostingSFUScreenShare,
            getIsHostingSFUScreenShare: getIsHostingSFUScreenShare,

            getIsSharingAppScreen: getIsSharingAppScreen,

            setScreenShareType: setScreenShareType,
            getScreenShareType: getScreenShareType,

            getScreenShareHostType: getScreenShareHostType,
            setScreenShareHostType: setScreenShareHostType,

            getIsScreenShareActive: getIsScreenShareActive,
            getIsVideoShareActive: getIsVideoShareActive,
            getIsLocalContentShared: getIsLocalContentShared,
            setIsLocalContentShared: setIsLocalContentShared
        };

        initSubscriptions();

        $rootScope.$on('content-initiating', onContentInitiating);
        $rootScope.$on('content-init-cancelled', onContentInitCancelled);
        $rootScope.$on('cancel-content-initiation', cancelContentInitiation);
        $rootScope.$on('content-playing', onContentPlaying);
        $rootScope.$on('content-stopped', onContentStopped);
        $rootScope.$on('content-playback-toggled', onContentPlaybackToggled);
        $rootScope.$on('content-status', onContentStatus);
        $rootScope.$on('file-not-found', onFileNotFound);
        $rootScope.$on('content-maximize-status', onContentMaximizeStatus);
        $rootScope.$on('clear-content-override', onClearContentOverride);
        $rootScope.$on('content-init-timed-out', onContentInitTimedOut);
        $rootScope.$on('node-reconnected', onNodeReconnected);
        $rootScope.$on('electron-screen-selected', onElectronScreenSelected);
        $rootScope.$on('$destroy', onScopeDestroyed);

        return service;

        ////////////////////////

        function isContentInitiating() {
            return service.getContentOwner() !== 0 && service.getContentType() === '' ? true : false;
        }

        function onContentInitiating(e, data) {
            //When initiating, nobody else can play new content
            logService.log('Received from server - Content initiating:', data);

            service.setContentOwner(data.ownerID);
            service.setCurrentContentObject(data);

            if (service.getContentOwner() !== attendeeService.getAttendantId()) {
                return;
            }

            //If you own the content, broadcast start event...
            //
            //Slides/Video will start automatically
            //Screenshare requires user to select a screen before continuing
            if (data.type === 'screenshare') {
                if (!attendeeService.getIsSfuEnabled()) {
                    $rootScope.$broadcast('start-screenshare-verto-call');
                }
            }

            service.startContentInitTimeout(data.type);
        }

        function startContentInitTimeout(contentType) {
            var timeoutLength = 30; //In seconds

            //Content initiation should be very quick for slides/video...
            //If it ever gets stuck in this state, we want to track with analytics
            contentInitiationTimeout = $timeout(function () {
                if (service.isContentInitiating()) {
                    analyticsWrapperService.eventTrack(
                        'Meeting - Content Initiating for ' + timeoutLength + ' seconds - ' + contentType
                    );
                }
            }, timeoutLength * 1000);
        }

        function cancelContentInitTimeout() {
            if (contentInitiationTimeout) {
                $timeout.cancel(contentInitiationTimeout);
                contentInitiationTimeout = null;
            }
        }

        function onContentInitCancelled(e, data) {
            logService.log('Received from server - Content init cancelled:', data.type);

            service.setContentOwner(0);
            service.cancelContentInitTimeout();
        }

        function onContentPlaying(e, data) {
            logService.log('Received from server - Content playing:', data);

            analyticsWrapperService.eventTrack('Meeting - Playing Content: ' + data.type, {
                category: 'content service'
            });

            // broadcast internal event to execute some logic before handle this event (ex. toggle simulcast if needed)
            $rootScope.$broadcast('internal-content-playing', data);

            service.cancelContentInitTimeout();

            service.setContentType(data.type);
            service.setContentPath(data.path || '');
            service.setCurrentContentObject(data);

            var notificationMessage = '';

            var initialPlayStatus = data.playStatus || '';

            const contentOwner = service.getContentOwner();

            if (contentOwner === 0) {
                //this implies playback has already stopped.
                //case happens when clip is too short
                //or network lag
                return;
            }

            //Broadcast event to respective content ctrls
            switch (data.type) {
                case 'screenshare':
                    $rootScope.$broadcast('screenshare-started', contentOwner);

                    if (!service.getIsFilePlay()) {
                        notificationMessage = data.requesterName
                            ? localizationService.translate(
                                  'SCREENSHARE.NOTIFICATIONS.PERSON_STARTED_NEW_SCREENSHARE',
                                  { person: data.requesterName }
                              )
                            : localizationService.translate('SCREENSHARE.NOTIFICATIONS.STARTED_NEW_SCREENSHARE');
                    } else {
                        notificationMessage = data.requesterName
                            ? localizationService.translate('SCREENSHARE.NOTIFICATIONS.PERSON_STARTED_NEW_VIDEO', {
                                  person: data.requesterName
                              })
                            : localizationService.translate('SCREENSHARE.NOTIFICATIONS.STARTED_NEW_VIDEO');
                    }
                    if (!data.screenShareAlreadyStarted) {
                        // Don't show alert if screenshare already started and attendee joins later.
                        notificationService.show(notificationMessage, 'success');
                    }

                    break;
                case 'slides':
                    $rootScope.$broadcast('slide-show-loaded', contentOwner, initialPlayStatus);

                    notificationMessage = data.requesterName
                        ? localizationService.translate('SCREENSHARE.NOTIFICATIONS.PERSON_STARTED_NEW_SLIDESHOW', {
                              person: data.requesterName
                          })
                        : localizationService.translate('SCREENSHARE.NOTIFICATIONS.STARTED_NEW_SLIDESHOW');
                    notificationService.show(notificationMessage, 'success');

                    break;
                case 'video':
                    $rootScope.$broadcast('video-playing', contentOwner, initialPlayStatus);

                    notificationMessage = data.requesterName
                        ? localizationService.translate('SCREENSHARE.NOTIFICATIONS.PERSON_STARTED_NEW_VIDEO', {
                              person: data.requesterName
                          })
                        : localizationService.translate('SCREENSHARE.NOTIFICATIONS.STARTED_NEW_VIDEO');
                    notificationService.show(notificationMessage, 'success');
                    break;
            }
        }

        function onContentPlaybackToggled(e, data) {
            logService.log('Received from server - Content playback toggled:', data.type);

            $rootScope.$broadcast('video-playback-toggled');
            var notificationMessage =
                data.videoPaused === true
                    ? localizationService.translate('VIDEO_SHARE.PERSON_PAUSED', { person: data.requesterName })
                    : localizationService.translate('VIDEO_SHARE.PERSON_CONTINUED', { person: data.requesterName });
            notificationService.show(notificationMessage, 'success');
        }

        function onContentStopped(e, data) {
            logService.log('Received from server - Content stopped:', data.type);

            analyticsWrapperService.eventTrack('Meeting - Content stopped: ' + data.type, {
                category: 'content service'
            });

            // broadcast internal event to execute some logic before handle this event (ex. toggle simulcast if needed)
            $rootScope.$broadcast('internal-content-stopped', data);

            var isFilePlay = service.getIsFilePlay();
            service.cancelContentInitTimeout();
            service.resetContentProperties();

            var notificationMessage = '';

            // ideally, startNewContent should be done *after* stop/end events are broadcasted. But since that is very old
            // code, I am doing that for the multishare case, for which it is required.

            var hasMultishare = configService.getHasMultishare();

            if (!hasMultishare && contentOverride) {
                service.startNewContent(contentOverrideObj.type, contentOverrideObj.path, contentOverrideObj.ref);
                onClearContentOverride();
            }

            switch (data.type) {
                case 'screenshare':
                    $rootScope.$broadcast('screenshare-ended');

                    if (!isFilePlay) {
                        notificationMessage = data.requesterName
                            ? localizationService.translate('SCREENSHARE.NOTIFICATIONS.PERSON_END_SCREENSHARE', {
                                  person: data.requesterName
                              })
                            : localizationService.translate('SCREENSHARE.NOTIFICATIONS.END_SCREENSHARE');
                    } else {
                        notificationMessage = data.requesterName
                            ? localizationService.translate('SCREENSHARE.NOTIFICATIONS.PERSON_END_VIDEO', {
                                  person: data.requesterName
                              })
                            : localizationService.translate('SCREENSHARE.NOTIFICATIONS.END_VIDEO');
                    }
                    notificationService.show(notificationMessage, 'success');

                    break;
                case 'slides':
                    $rootScope.$broadcast('slide-show-unloaded');

                    notificationMessage = data.requesterName
                        ? localizationService.translate('SCREENSHARE.NOTIFICATIONS.PERSON_END_SLIDESHOW', {
                              person: data.requesterName
                          })
                        : localizationService.translate('SCREENSHARE.NOTIFICATIONS.END_SLIDESHOW');
                    notificationService.show(notificationMessage, 'success');

                    break;
                case 'video':
                    $rootScope.$broadcast('video-stopped');

                    notificationMessage = data.requesterName
                        ? localizationService.translate('SCREENSHARE.NOTIFICATIONS.PERSON_END_VIDEO', {
                              person: data.requesterName
                          })
                        : localizationService.translate('SCREENSHARE.NOTIFICATIONS.END_VIDEO');
                    notificationService.show(notificationMessage, 'success');
                    break;
            }

            if (hasMultishare && contentOverride) {
                service.startNewContent(contentOverrideObj.type, contentOverrideObj.path, contentOverrideObj.ref);
                onClearContentOverride();
            }
        }

        function onContentStatus(e, data) {
            // broadcast internal event to execute some logic before handle this event (ex. toggle simulcast if needed)
            $rootScope.$broadcast('internal-content-status', data);

            if (attendeeService.getAttendantId() !== data.requesterID && !attendeeService.getIsPresenter()) {
                return;
            }

            logService.log('Received from server - Content status: ', data);

            service.setContentOwner(data.ownerID);
            if (!service.getCurrentContentObject()) {
                data.screenShareAlreadyStarted = true;
                $rootScope.$broadcast('content-playing', data);
            }

            if (data.state === 'running') {
                service.setCurrentContentObject(data);
                service.setContentType(data.type);
                service.setContentPath(data.path);
                var playStatus = data.playStatus || '';
                var videoPaused = data.paused;

                const contentOwner = service.getContentOwner();

                if (attendeeService.getAttendantId() === contentOwner) {
                    switch (data.type) {
                        case 'slides':
                            $rootScope.$broadcast('slide-show-loaded', contentOwner, playStatus);
                            break;
                        case 'video':
                            $rootScope.$broadcast('video-playing', contentOwner, playStatus, videoPaused);
                            break;
                    }
                }
            }

            if (data.state === 'stopped') {
                if (vertoService.isScreenShareCallConnected()) {
                    vertoService.forceScreenShareCleanUp();
                }

                service.resetContentProperties();

                //Tell ctrls to clean up content states
                $rootScope.$broadcast('content-cleanup');
            }
        }

        function onFileNotFound(e, data) {
            logService.log('File not found ' + data.file);
            if (data.attendeeID === attendeeService.getAttendantId()) {
                var closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                $window.swal(
                    {
                        title:
                            closeButtonHtml +
                            localizationService.translate('SCREENSHARE.DIALOG.FILE_NOT_FOUND', { file: data.file }),
                        showCancelButton: false,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                        closeOnConfirm: true,
                        html: true,
                        imageUrl: 'img/redesign/modal/pop-up-pic-error.svg'
                    },
                    function () {
                        service.cancelContentInitiation();
                    }
                );
            } else {
                service.cancelContentInitiation();
            }
        }

        // extracted in content.service.ts
        function isContentPlaying(filePath) {
            //If optional filePath parameter passed, check if that file is playing
            if (filePath) {
                const contentPath = service.getContentPath();
                var path = contentPath.substring(0, contentPath.lastIndexOf('/') + 1);
                return filePath === path;
            }

            //If no parameter, check if any file is playing
            return service.getContentType() !== '';
        }

        function getContentType() {
            return currentContentType;
        }

        function setContentType(value) {
            contentStateService.currentContentType = value;
        }

        function getContentOwner() {
            return currentContentOwner;
        }

        function setContentOwner(value) {
            contentStateService.currentContentOwner = value;
        }

        function getCurrentContentObject() {
            return currentContentObj;
        }

        function setCurrentContentObject(value) {
            contentStateService.currentContentObj = value;
        }

        function getContentPath() {
            return currentContentPath;
        }

        function setContentPath(value) {
            contentStateService.currentContentPath = value;
        }

        // extracted in content.service.ts
        function getIsFilePlay() {
            return !!service.getCurrentContentObject()?.isFilePlay;
        }

        // extracted in content.service.ts
        function getIsScreenShareActive() {
            return isScreenShareActive;
        }

        // extracted in content.service.ts
        function getIsVideoShareActive() {
            return isVideoShareActive;
        }

        function playContent(type, path, fileObj, isFilePlay) {
            logService.log('Telling server to play new content: ' + type);

            var msgObj = {
                message: 'toggle-content-init',
                data: { type: type, action: 'start', path: path || '', file: fileObj, isFilePlay: isFilePlay }
            };

            socketService.send(msgObj);

            if (type !== 'screenshare') {
                analyticsWrapperService.eventTrack('Meeting - content library - presenting ' + type, {
                    category: 'Content Library'
                });
            }
        }

        function cancelContentInitiation() {
            if (!service.isContentInitiating()) {
                logService.log('Content not initiating... returning from cancelContentInitiation');
                return;
            }

            logService.log('Telling server to cancel content initiation');

            var msgObj = {
                message: 'toggle-content-init',
                data: { action: 'cancel' }
            };

            socketService.send(msgObj);
        }

        function stopCurrentContent(isOverriding) {
            const contentType = service.getContentType();

            logService.log('Telling server to stop current content', contentType);

            var serverEvent = '';

            switch (contentType) {
                case 'screenshare':
                    serverEvent = 'stop-screenshare';
                    break;
                case 'slides':
                    serverEvent = 'unload-slides';
                    break;
                case 'video':
                    serverEvent = 'stop-video';
                    break;
            }

            var msgObj = {
                message: serverEvent,
                data: {}
            };

            if (isOverriding) {
                msgObj.data.overriding = true;
            }

            socketService.send(msgObj);
        }

        function promptUserOverride(newContentType, newContentPath, fileRef, hasMultishare) {
            if (hasMultishare === undefined) {
                hasMultishare = configService.getHasMultishare();
            }

            var allowNew = hasMultishare && newContentType == 'screenshare' && !service.getIsFilePlay();
            if (helperService.getIsRedesign() === true) {
                var closeButtonHtml = allowNew
                    ? '<button class="sweetalert-close-x override" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>'
                    : '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                $window.swal(
                    {
                        title:
                            closeButtonHtml +
                            localizationService.translate('SCREENSHARE.DIALOG.CONTENT_ALREADY_SHARED'),
                        text: !allowNew
                            ? localizationService.translate('SCREENSHARE.DIALOG.STOP_CONTENT_AND_PLAY_NEW_ONE')
                            : 'You may now choose between stopping the current screenshare and adding a secondary screen.' +
                              ' Please note that secondary screens will not be in spotlight in recording, and annotations will not be supported.',
                        showCancelButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: allowNew
                            ? 'Replace existing'
                            : localizationService.translate('SCREENSHARE.SHARE_TEXT'),
                        cancelButtonText: allowNew
                            ? 'Add another'
                            : localizationService.translate('COMMON.CANCEL_TEXT'),
                        closeOnConfirm: true,
                        html: true,
                        imageUrl: 'img/redesign/modal/pop-up-pic-playing-content.svg',
                        customClass: 'mute-everyone-modal auto-size' + (allowNew ? ' max-width' : '')
                    },
                    function (choice) {
                        //User clicked 'Okay'
                        if (choice) {
                            service.overrideCurrentContent(newContentType, newContentPath || '', fileRef);
                        } else if (allowNew) {
                            logService.log('Publishing screen as video instead of content');
                            service.startNewContent(newContentType, newContentPath || '', fileRef);
                        }
                        if (allowNew) {
                            analyticsWrapperService.eventTrack(
                                'Meeting - Screenshare prompt ' + (choice ? 'override' : 'add new')
                            );
                        }
                    }
                );

                if (allowNew) {
                    analyticsWrapperService.eventTrack('Meeting - Screenshare prompt shown');

                    // hacky way to close the alert when x is clicked.
                    var closeButton = $window.$('button.override.sweetalert-close-x')[0];
                    if (closeButton) {
                        closeButton.onclick = function (event) {
                            event.stopImmediatePropagation();
                            $window.swal.close();
                            logService.log('Canceling multishare prompt');
                            analyticsWrapperService.eventTrack('Meeting - Screenshare prompt cancel');
                            return false;
                        };
                    }
                }
            } else {
                //TODO: REMOVE POST-REDESIGN
                $window.swal(
                    {
                        title: localizationService.translate('SCREENSHARE.DIALOG.ANOTHER_CONTENT_PLAYING.TITLE'),
                        text: hasMultishare
                            ? localizationService.translate(
                                  'SCREENSHARE.DIALOG.ANOTHER_CONTENT_PLAYING.TEXT_MULTISHARE'
                              )
                            : localizationService.translate('SCREENSHARE.DIALOG.ANOTHER_CONTENT_PLAYING.TEXT'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: allowNew
                            ? localizationService.translate(
                                  'SCREENSHARE.DIALOG.ANOTHER_CONTENT_PLAYING.CONFIRM_STOP_AND_SHARE_NEW'
                              )
                            : localizationService.translate('COMMON.YES_TEXT'),
                        cancelButtonText: allowNew
                            ? localizationService.translate(
                                  'SCREENSHARE.DIALOG.ANOTHER_CONTENT_PLAYING.CANCEL_SHARE_WITHOUT_STOPPING'
                              )
                            : localizationService.translate('COMMON.CANCEL_TEXT'),
                        closeOnConfirm: true
                    },
                    function (choice) {
                        //User clicked 'Okay'
                        if (choice) {
                            service.overrideCurrentContent(newContentType, newContentPath || '', fileRef);
                        } else if (allowNew) {
                            logService.log('Publishing screen as video instead of content');
                            service.startNewContent(newContentType, newContentPath || '', fileRef);
                        }
                    }
                );
            }
        }

        function startNewContent(newContentType, newContentPath, fileRef) {
            if (newContentType === 'screenshare') {
                if (attendeeService.getIsSfuEnabled() && !helperService.isElectron()) {
                    $rootScope.$broadcast('start-sfu-screenshare');
                } else {
                    //Electron should still call this if in SFU mode
                    $rootScope.$broadcast('start-screenshare');
                }
            } else if (newContentType === 'sfu-video') {
                if (helperService.browserHasWebRTC() && attendeeService.getIsSfuEnabled()) {
                    $timeout(function () {
                        $rootScope.$broadcast('start-local-file-share');
                    }, 1000);
                }
            } else {
                playContent(newContentType, newContentPath, fileRef);
            }
        }

        function overrideCurrentContent(newContentType, newContentPath, fileRef) {
            if (!service.isContentPlaying()) {
                return;
            }

            contentOverride = true;
            contentOverrideObj.type = newContentType;
            contentOverrideObj.path = newContentPath;
            contentOverrideObj.ref = fileRef;

            logService.log(
                'Override current content with: ' + contentOverrideObj.type + ' - ' + contentOverrideObj.path
            );

            service.stopCurrentContent(true);
        }

        function toggleMaximizeContent() {
            var msgObj = {
                message: '',
                data: {}
            };
            if (_isContentMaximized === false) {
                msgObj.message = 'maximize-content';
                analyticsWrapperService.eventTrack('meeting - presenting hide webcams', {
                    category: 'content service'
                });
            } else {
                msgObj.message = 'restore-content';
                analyticsWrapperService.eventTrack('meeting - presenting show webcams', {
                    category: 'content service'
                });
            }

            socketService.send(msgObj);
        }

        function onContentMaximizeStatus(e, status) {
            _isContentMaximized = status;
        }

        function isContentMaximized() {
            return _isContentMaximized;
        }

        function init() {
            logService.log('ContentService init');
            socketService.send({
                message: 'retrieve-content-status',
                data: {}
            });
        }

        function onClearContentOverride() {
            if (contentOverride) {
                logService.log('Clearing content override...');

                contentOverride = false;
                contentOverrideObj.type = '';
                contentOverrideObj.path = '';
                contentOverrideObj.ref = null;
            }
        }

        function hasUnrequestedStop() {
            return unrequestedStopType ? true : false;
        }

        function setUnrequestedStopType(newVal) {
            unrequestedStopType = newVal;
        }

        function getUnrequestedStopType() {
            return unrequestedStopType;
        }

        function onContentInitTimedOut(e, contentType) {
            if (contentType === 'screenshare') {
                //Since server already cancels content init on timeout,
                //pass 'true' param to prevent duplicate content-init event
                vertoService.forceScreenShareCleanUp(true);
                vertoService.setScreenShareTCPFailed(true);
            }

            var closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            $window.swal({
                title:
                    closeButtonHtml +
                    localizationService.translate('SCREENSHARE.DIALOG.THERE_IS_AN_ISSUE_SHARING_CONTENT'),
                text: localizationService.translate('SCREENSHARE.DIALOG.TRY_SHARE_CONTENT_AGAIN'),
                showCancelButton: false,
                confirmButtonColor: brandingService.getBaseColor(),
                confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                closeOnConfirm: true,
                html: true,
                imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
            });
        }

        function resetContentProperties() {
            service.setContentType('');
            service.setContentPath('');
            service.setContentOwner(0);
            service.setCurrentContentObject(null);
        }

        function onNodeReconnected() {
            logService.log('contentService - Node reconnected... retrieving content status');
            socketService.send({
                message: 'retrieve-content-status',
                data: {}
            });
        }

        function setIsHostingSFUScreenShare(newIsHostingSFUScreenShare, noSendToServer, publisherData) {
            if (!noSendToServer) {
                // this is forced even if state is already the same, so that it can sync the server server correctly after reconnection,
                // if it was not correct, e.g., client thinks screen share is active, but server thinks it is not.
                socketService.send({
                    message: newIsHostingSFUScreenShare ? 'sfu-screenshare-started' : 'sfu-screenshare-stopped',
                    data: publisherData
                });
            }

            if (isHostingSFUScreenShare !== newIsHostingSFUScreenShare) {
                isHostingSFUScreenShare = newIsHostingSFUScreenShare;

                if (isHostingSFUScreenShare) {
                    $rootScope.$broadcast('sfu-screenshare-started');
                } else {
                    $rootScope.$broadcast('sfu-screenshare-stopped');
                }
            }
        }

        function getIsHostingSFUScreenShare() {
            return isHostingSFUScreenShare;
        }

        function onElectronScreenSelected(e, data) {
            logService.log('Electron screen selected, screen id:', data.id);
            logService.log('Electron screen selected, display id:', data.displayId);
            var isSharingAppScreen = data.id && data.id.indexOf('screen') != 0;
            screenShareType = isSharingAppScreen ? 'window' : 'monitor';
        }

        function onScopeDestroyed() {
            subscriptionService.endSubscription(rootSubscription);
        }

        function getIsSharingAppScreen() {
            return screenShareType === 'window' || screenShareType === 'browser';
        }

        function setScreenShareType(type) {
            screenShareType = type;
        }

        function getScreenShareType() {
            return screenShareType;
        }

        function getScreenShareHostType() {
            return hostType;
        }

        function setScreenShareHostType(type) {
            hostType = type;
        }

        //#region AngularSubscriptions

        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
            subscribeToState();
            subscribeToCalculatedProperties();
        }

        function subscribeToState() {
            rootSubscription.add(
                contentStateService.currentContentOwner$.subscribe(next => {
                    currentContentOwner = next;
                })
            );

            rootSubscription.add(
                contentStateService.currentContentObj$.subscribe(next => {
                    currentContentObj = next;
                })
            );

            rootSubscription.add(
                contentStateService.currentContentType$.subscribe(next => {
                    currentContentType = next;
                })
            );

            rootSubscription.add(
                contentStateService.currentContentPath$.subscribe(next => {
                    currentContentPath = next;
                })
            );

            rootSubscription.add(
                contentStateService.isLocalContentShared$.subscribe(next => {
                    isLocalContentShared = next;
                })
            );
        }

        function subscribeToCalculatedProperties() {
            rootSubscription.add(
                contentUpgradedService.isVideoShareActive$.subscribe(next => {
                    isVideoShareActive = next;
                })
            );

            rootSubscription.add(
                contentUpgradedService.isScreenShareActive$.subscribe(next => {
                    isScreenShareActive = next;
                })
            );
        }

        function setIsLocalContentShared(isConnected, isScreenVideo) {
            contentStateService.isLocalContentShared = isConnected || isScreenVideo;
        }

        function getIsLocalContentShared() {
            return isLocalContentShared;
        }

        //#endregion
    }
]);
